import React from 'react'
import { Link } from 'react-router-dom'

import UsePlural from '@connects/plural'
import UseSingular from '@connects/singular'
import combine from '@connects/combine'

import PageHeader from '@components/PageHeader/PageHeader'
import NoteInput from './components/NoteInput/NoteInput'
import NoteList from './components/NoteList/NoteList'

import './Notes.scss'

export default function(resource) {

	@combine({
		notes: UsePlural('note'),
		parentResource: UseSingular(resource),
	})
	class NotesContainer extends React.Component {

		constructor(props) {
			super(props);
			this.referencedObjectId = this.props.match.params.id;
		}

		addNote(values, actions) {

			return this.props.notes.actions.create({
				referencedObject: this.referencedObjectId,
				content: values.content,
			})
			.then(() => {
				// TODO: detect pass/fail (need to manage success/fail state in redux)
				actions.resetForm();
				actions.setSubmitting(false)
			})
		}

		async componentDidMount() {
			const { notes, parentResource } = this.props;

			notes.actions.getMany({
				referencedObject: this.referencedObjectId,
				limit: 999, // TODO: make it possible to set unlimited
				sortDir: 'desc'
			})

			parentResource.actions.get(this.props.match.params.id)
		}
		
		// Render 
		
		render() {
			const notesData = this.props.notes.data;
			const resourceData = this.props.parentResource.data ? this.props.parentResource.data : {};
			
			return (
				<main className="Notes page-content">
					<PageHeader title={`${resourceData.label ? resourceData.label : ''} > Notes`}>
						<Link to={`/${resource}/${resourceData._id}`}>Profile</Link>
					</PageHeader>
					<NoteInput onSubmit={::this.addNote}/>
					<NoteList notes={notesData} />
				</main>
			)
		}

	}

	return NotesContainer;
}



// WEBPACK FOOTER //
// ./src/scenes/Notes/createNotesContainer.jsx